import React, { useState } from 'react';
import { PDF_LAYOUT_STEP, PDF_SIZE_STEP } from '../helpers/pdfLayoutUtils';

const btnClass = 'w-9 h-9 flex items-center justify-center rounded-lg border border-gray-300 bg-white hover:bg-gray-50 text-sm font-bold shadow-sm';
const smBtnClass = 'px-2 py-1 rounded border border-gray-300 bg-white hover:bg-gray-50 text-xs font-semibold';

function PdfLayoutJoystick({
  sectionLabel,
  offset,
  onNudge,
  onReset,
  enableSize = false,
  onResize,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const step = PDF_LAYOUT_STEP;
  const sizeStep = PDF_SIZE_STEP;

  return (
    <div className="border border-gray-200 rounded-lg bg-gray-50 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-full flex items-center justify-between gap-2 p-3 text-left hover:bg-gray-100 transition-colors"
        aria-expanded={open}
      >
        <span className="text-xs font-semibold text-gray-700">{sectionLabel}</span>
        <div className="flex items-center gap-2 shrink-0">
          <span className="text-[10px] text-gray-500 font-mono hidden sm:inline">
            x:{offset.x} y:{offset.y}
            {enableSize ? ` w:${offset.w} h:${offset.h}` : ''}
          </span>
          <span className="text-[10px] text-indigo-600 font-medium">{open ? '▲' : '▼'}</span>
        </div>
      </button>
      {open && (
        <div className="px-3 pb-3 border-t border-gray-200 pt-2">
          <p className="text-[10px] text-gray-500 font-mono mb-2 sm:hidden">
            x:{offset.x} y:{offset.y}
            {enableSize ? ` w:${offset.w} h:${offset.h}` : ''}
          </p>
          <div className="inline-grid grid-cols-3 gap-1">
            <div />
            <button type="button" className={btnClass} onClick={() => onNudge(0, -step)} title="Move up">
              ↑
            </button>
            <div />
            <button type="button" className={btnClass} onClick={() => onNudge(-step, 0)} title="Move left">
              ←
            </button>
            <button type="button" className={`${btnClass} text-xs`} onClick={onReset} title="Reset">
              ⌂
            </button>
            <button type="button" className={btnClass} onClick={() => onNudge(step, 0)} title="Move right">
              →
            </button>
            <div />
            <button type="button" className={btnClass} onClick={() => onNudge(0, step)} title="Move down">
              ↓
            </button>
            <div />
          </div>
          {enableSize && onResize && (
            <div className="mt-3 space-y-2">
              <div className="flex items-center justify-between gap-1">
                <span className="text-[10px] text-gray-500 w-10">Width</span>
                <button type="button" className={smBtnClass} onClick={() => onResize(-sizeStep, 0)}>−</button>
                <button type="button" className={smBtnClass} onClick={() => onResize(sizeStep, 0)}>+</button>
              </div>
              <div className="flex items-center justify-between gap-1">
                <span className="text-[10px] text-gray-500 w-10">Height</span>
                <button type="button" className={smBtnClass} onClick={() => onResize(0, -sizeStep)}>−</button>
                <button type="button" className={smBtnClass} onClick={() => onResize(0, sizeStep)}>+</button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default PdfLayoutJoystick;
